import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function CopyApiKeyButton({ handler }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} variant="success" size="md" className="text-success btn-link edit" title={t("common.actions.copyApiKey")}>
        <i className="fa fa-key" />
      </Button>
    </div>
  );
}
